import z from 'zod';
import { DocumentMetaTs, LocaleTs } from "../../common";
import { SingleTypes } from '@/providers/strapi';
import { ContentContext } from '../../content-provider';
import { useContext } from 'react';
import { OmitDocumentMeta } from '@/providers/strapi/client/types';

import { DownloadPopupCardTs } from '@/providers/strapi/content/types/components/traveler.component'


export type DownloadPopup = z.output<typeof DownloadPopupTs>;
export const DownloadPopupTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  downloadPopup: DownloadPopupCardTs
})

export const DOWNLOAD_POPUP = "download-popup";
export function useDownloadPopup<
  K extends keyof Omit<DownloadPopup, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): DownloadPopup[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`DownloadPopup content not found`)
  const DownloadPopup = content[DOWNLOAD_POPUP] as DownloadPopup;
  if (!DownloadPopup || !DownloadPopup[entity]) throw new Error(`${entity} content not found`)
  return DownloadPopup[entity]
}
